var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookingStep02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.9205 15.061L31.2753 17.2612C28.0997 17.681 25.8656 20.5956 26.2854 23.7713L31.4905 63.1487C31.9103 66.3243 34.8249 68.5584 38.0006 68.1386L54.6458 65.9384C57.8214 65.5186 60.0555 62.604 59.6357 59.4283L54.4306 20.0509C54.0108 16.8752 51.0961 14.6412 47.9205 15.061Z",
    fill: "white",
    stroke: "url(#paint0_linear_801_3425)",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0005 27.6486L35.4411 29.1766L35.7373 31.4171L47.2967 29.8891L47.0005 27.6486Z",
    fill: "url(#paint1_linear_801_3425)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9193 33.529L36.7603 34.6075L36.987 36.3226L45.146 35.2441L44.9193 33.529Z",
    fill: "url(#paint2_linear_801_3425)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4542 37.5647L37.2952 38.6432L37.5219 40.3583L45.6809 39.2798L45.4542 37.5647Z",
    fill: "url(#paint3_linear_801_3425)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0706 42.9584L38.1047 44.5402L38.6355 48.5552L50.6014 46.9735L50.0706 42.9584Z",
    fill: "url(#paint4_linear_801_3425)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2351 71.1814C58.8451 70.9514 56.8051 67.1214 56.2451 64.2714C55.7251 61.6414 56.6951 61.0814 56.2451 57.7414C55.9751 55.7214 55.5351 52.4114 53.1751 50.6314C51.1651 49.1214 50.0451 50.4214 47.0251 48.7114C44.8651 47.4814 42.6651 45.2414 42.9951 43.5214C43.0851 43.0414 43.5751 41.6014 43.5751 41.6014L55.0951 43.3314C55.0951 43.3314 57.7651 45.4714 57.9751 45.6314C64.9751 51.2414 68.4751 54.0414 69.3051 56.7714C71.1651 62.8814 65.0551 71.5514 61.2351 71.1814Z",
    fill: "url(#paint5_linear_801_3425)",
    stroke: "white",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7651 8.85136L12.8151 12.9114C11.1951 13.2014 10.1151 14.7414 10.3951 16.3614L12.6151 28.9114C12.9051 30.5314 14.4451 31.6114 16.0651 31.3314L39.0151 27.2714C40.6351 26.9814 41.7151 25.4414 41.4351 23.8214L39.2151 11.2714C38.9251 9.65136 37.3851 8.57136 35.7651 8.85136Z",
    fill: "url(#paint6_linear_801_3425)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0451 31.9214L32.2751 27.8914L38.0951 27.0614L38.8651 31.4014C38.9051 31.6114 38.8151 31.8214 38.6251 31.9414C38.5651 31.9814 38.4951 32.0014 38.4351 32.0214C38.2951 32.0414 38.1551 32.0214 38.0451 31.9314V31.9214Z",
    fill: "url(#paint7_linear_801_3425)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8551 22.5914C21.7442 22.5914 22.4651 21.8705 22.4651 20.9814C22.4651 20.0922 21.7442 19.3714 20.8551 19.3714C19.9659 19.3714 19.2451 20.0922 19.2451 20.9814C19.2451 21.8705 19.9659 22.5914 20.8551 22.5914Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9151 21.7014C26.8042 21.7014 27.5251 20.9805 27.5251 20.0914C27.5251 19.2022 26.8042 18.4814 25.9151 18.4814C25.0259 18.4814 24.3051 19.2022 24.3051 20.0914C24.3051 20.9805 25.0259 21.7014 25.9151 21.7014Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9851 20.8014C31.8742 20.8014 32.5951 20.0805 32.5951 19.1914C32.5951 18.3022 31.8742 17.5814 30.9851 17.5814C30.0959 17.5814 29.3751 18.3022 29.3751 19.1914C29.3751 20.0805 30.0959 20.8014 30.9851 20.8014Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_801_3425",
    x1: 25.9059,
    y1: 43.8583,
    x2: 59.9959,
    y2: 39.3583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF3825"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_801_3425",
    x1: 35.6603,
    y1: 30.2773,
    x2: 47.2202,
    y2: 28.7493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF3825"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_801_3425",
    x1: 37.0908,
    y1: 35.4859,
    x2: 45.2673,
    y2: 34.4051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF3825"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_801_3425",
    x1: 37.6259,
    y1: 39.5226,
    x2: 45.8023,
    y2: 38.4418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF3825"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_801_3425",
    x1: 38.1879,
    y1: 46.043,
    x2: 50.1237,
    y2: 44.4653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF3825"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_801_3425",
    x1: 44.7251,
    y1: 57.4414,
    x2: 69.0651,
    y2: 54.2214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF3825"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_801_3425",
    x1: 11.5072,
    y1: 22.6476,
    x2: 40.3299,
    y2: 17.5498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF3825"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_801_3425",
    x1: 32.7254,
    y1: 30.421,
    x2: 38.5056,
    y2: 29.3986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58C22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF3825"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingStep02);
export default __webpack_public_path__ + "static/media/booking-step-02.a68043926098154c3e8c27755ac9027d.svg";
export { ForwardRef as ReactComponent };